import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClient,
  HttpClientModule} from '@angular/common/http';

import {
  TranslateModule,
  TranslateLoader
} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {LocaleSelectComponent} from './locale-select/locale-select.component';

// AoT requires an exported function for factories
export let HttpLoaderFactory = (http: HttpClient): TranslateHttpLoader => {
  return new TranslateHttpLoader(http);
};

@NgModule({
  declarations: [
    LocaleSelectComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [
          HttpClient
        ]
      }
    })
  ],
  exports: [
    LocaleSelectComponent,
    TranslateModule
  ]
})
export class LocalisationModule { }
